import React from "react";

// Default data for the table
export const defaultSustainabilityTargetsData = [
  {
    sustainabilityMatter: "",
    targetDescription: "",
    targetType: "",
    targetYear: "",
    baselineYear: "",
  },
  {
    sustainabilityMatter: "",
    targetDescription: "",
    targetType: "",
    targetYear: "",
    baselineYear: "",
  },
];

const SustainabilityTargetsTable = ({ targetsData, setTargetsData }) => {
  const handleChange = (index, field, value) => {
    const updatedData = [...targetsData];
    updatedData[index][field] = value;
    setTargetsData(updatedData);
  };

  React.useEffect(() => {
    if (!targetsData || targetsData.length === 0) {
      setTargetsData(defaultSustainabilityTargetsData);
    }
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Sustainability Matter</th>
            <th style={tableHeaderStyle}>Target description</th>
            <th style={tableHeaderStyle}>Target Type (Absolute/Relative)</th>
            <th style={tableHeaderStyle}>Target Year</th>
            <th style={tableHeaderStyle}>Baseline year</th>
          </tr>
        </thead>
        <tbody>
          {targetsData.map((row, index) => (
            <tr key={index}>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.sustainabilityMatter}
                  onChange={(e) =>
                    handleChange(index, "sustainabilityMatter", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.targetDescription}
                  onChange={(e) =>
                    handleChange(index, "targetDescription", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.targetType}
                  onChange={(e) =>
                    handleChange(index, "targetType", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.targetYear}
                  onChange={(e) =>
                    handleChange(index, "targetYear", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.baselineYear}
                  onChange={(e) =>
                    handleChange(index, "baselineYear", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (consistent with previous tables)
const tableHeaderStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default SustainabilityTargetsTable;
